import { createSelector } from "reselect";
import { initialState } from "./reducer";

/**
 * Direct selector to the newTreatmentResultStep state domain
 */

const selectNewTreatmentResultStepDomain = state =>
  state.get("newTreatmentResultStep", initialState);

/**
 * Other specific selectors
 */
export const makeSelectLoading = () =>
  createSelector(selectNewTreatmentResultStepDomain, substate =>
    substate.get("loading"),
  );

export const makeSelectPlanActivityResult = () =>
  createSelector(selectNewTreatmentResultStepDomain, substate =>
    substate.get("planActivityResult"),
  );

export const makeSelectPlanActivityResultError = () =>
  createSelector(selectNewTreatmentResultStepDomain, substate =>
    substate.get("planActivityResultError"),
  );

/**
 * Default selector used by NewTreatmentResultStep
 */

const makeSelectNewTreatmentResultStep = () =>
  createSelector(selectNewTreatmentResultStepDomain, substate =>
    substate.toJS(),
  );

export default makeSelectNewTreatmentResultStep;
export { selectNewTreatmentResultStepDomain };
